import { Flex } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';

import type {
  SpecialTypeConditionsInputMap,
  SpecialTypeConditionsInputMapItem,
} from '@jane/business-admin/types';

import { Bundle } from './special_types/conditions/Bundle';
import { SpendingThreshold } from './special_types/conditions/SpendingThreshold';

const getSpecialTypeConditionsData: any = ({
  specialTypeKey,
  subKey,
}: {
  specialTypeKey: string;
  subKey: keyof SpecialTypeConditionsInputMapItem;
}) => {
  const specialTypeMap: SpecialTypeConditionsInputMap = {
    bundle: {
      name: 'display.bundle',
      options: [
        {
          rule: 'required_rules',
          value: 'threshold_number_of_items_in_cart',
          label: 'Minimum products requirement',
        },
        {
          rule: 'discounted_rules',
          value: 'max_number_of_discounted_products',
          label: 'Maximum products discounted',
        },
      ],
    },
    spending_threshold: {
      name: 'display.spending_threshold',
      options: [
        {
          rule: 'required_rules',
          value: 'cart_threshold',
          label: 'Minimum spend',
        },
        {
          rule: 'discounted_rules',
          value: 'max_number_of_discounted_products',
          label: 'Maximum products discounted',
        },
      ],
    },
  };

  return specialTypeMap[specialTypeKey as keyof typeof specialTypeMap]?.[
    subKey
  ];
};

export const SpecialTypeConditionsCriteria = ({
  isCreateMode = false,
  rule,
}: {
  isCreateMode?: boolean;
  rule: string;
}) => {
  const { watch, getValues } = useFormContext();
  const specialTypeWatch = watch('special_type');
  const specialTypeValue = getValues('special_type');

  const specialType = specialTypeWatch || specialTypeValue;

  const specialTypeConditions = getSpecialTypeConditionsData({
    specialTypeKey: specialType,
    subKey: 'options',
  })?.find((option: any) => option.rule === rule);

  if (specialType === 'bundle') {
    return (
      <Flex width="100%">
        <Bundle
          name={getSpecialTypeConditionsData({
            specialTypeKey: specialType,
            subKey: 'name',
          })}
          isCreateMode={isCreateMode}
          options={[specialTypeConditions]}
        />
      </Flex>
    );
  } else if (specialType === 'spending_threshold') {
    return (
      <Flex width="100%">
        <SpendingThreshold
          name={getSpecialTypeConditionsData({
            specialTypeKey: specialType,
            subKey: 'name',
          })}
          isCreateMode={isCreateMode}
          options={[specialTypeConditions]}
        />
      </Flex>
    );
  }

  return null;
};
